import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledSelectContainer,
  StyledLabel,
  StyledSelect,
  StyledCaret
} from './Styles';

const propTypes = {
  testId: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string
    })
  ),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultLabel: PropTypes.string,
  onChange: PropTypes.func
};

const defaultProps = {
  testId: undefined,
  children: undefined,
  className: undefined,
  options: [],
  defaultValue: '',
  defaultLabel: undefined,
  onChange: () => {}
};

const Select = ({
  children,
  className,
  testId,
  options = [],
  defaultValue,
  defaultLabel,
  onChange
}) => (
  <StyledSelectContainer className={className}>
    <StyledLabel htmlFor={className}>{children}</StyledLabel>
    <StyledSelect
      id={className}
      data-testid={testId}
      onChange={e => {
        if (e?.target?.value) {
          onChange(parseInt(e?.target?.value, 10));
        }
      }}
      defaultValue={defaultLabel}
      value={defaultLabel ? undefined : defaultValue}
    >
      {options?.map(({ id, value, label, disabled }) => (
        <React.Fragment key={id || value}>
          <option value={value} disabled={disabled}>
            {label}
          </option>
        </React.Fragment>
      ))}
    </StyledSelect>
    <StyledCaret />
  </StyledSelectContainer>
);

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export default Select;
